// extracted by mini-css-extract-plugin
export default {"bordered":"styles_bordered__jmg0L"};